import { __zcFin, __zcIT, __zcITc, __zcMkv } from "__zod-compiler-runtime__";
import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {LinkSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import {PrimerComponentLabelSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentLabel'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

import {GenericAssetSchema} from './generic-asset'
import {GenericConditionalCTAsSchema} from './generic-conditional-ctas'
import {GenericCTAGroupSchema} from './generic-cta-group'
import {GenericCTASetSchema} from './generic-cta-set'

export const GENERIC_CONTENT = 'genericContent'

export const GenericContentSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor(GENERIC_CONTENT, {
  fields: z.lazy(() =>
    z.object({
      id: z.string().optional(),
      htmlId: z.string().optional(),
      label: safeOptional(PrimerComponentLabelSchema),
      heading: z.string().optional(),
      subheading: safeOptional(RichTextSchema),
      text: safeOptional(RichTextSchema),
      link: safeOptional(LinkSchema),
      links: safeOptional(z.array(LinkSchema).max(2)),
      ctas: safeOptional(z.array(GenericCTAGroupSchema)),
      cta: safeOptional(z.union([GenericCTAGroupSchema, GenericCTASetSchema, GenericConditionalCTAsSchema])),
      media: safeOptional(z.array(GenericAssetSchema)),
      content: safeOptional(z.array(z.any())),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["label"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["subheading"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["text"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["link"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["links"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["ctas"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["cta"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["media"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["content"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __rfp_0=__rf[0].safeParse.bind(__rf[0]);
var __rfn_15=__rf[1];
var __rfn_19=__rf[2];
var __rfn_22=__rf[3];
var __rfn_25=__rf[4];
var __rfn_28=__rf[5];
var __rfn_31=__rf[6];
var __rfn_34=__rf[7];
var __rfn_37=__rf[8];
var __rfn_40=__rf[9];
function safeParse_GenericContentSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_r0=__rfp_0(__sv_6);if(!__rf_r0.success){var __rf_i0=__rf_r0.error.issues;for(var __rf_j0=0;__rf_j0<__rf_i0.length;__rf_j0++){_e.push({...__rf_i0[__rf_j0],path:["sys","contentType"].concat(__rf_i0[__rf_j0].path)});}}else{__sv_6=__rf_r0.data;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["id"];if(__sv_11!==undefined){if(typeof __sv_11!=="string"){_e.push(__zcIT("string",__sv_11,["fields","id"]));}
}
var __sv_12=__sv_9["htmlId"];if(__sv_12!==undefined){if(typeof __sv_12!=="string"){_e.push(__zcIT("string",__sv_12,["fields","htmlId"]));}
}
var __sv_13=__sv_9["label"];if(__sv_13!==undefined){var __ib_14=_e.length;if(_e.length===__ib_14){__sv_13=__rfn_15(__sv_13);}
}
var __sv_16=__sv_9["heading"];if(__sv_16!==undefined){if(typeof __sv_16!=="string"){_e.push(__zcIT("string",__sv_16,["fields","heading"]));}
}
var __sv_17=__sv_9["subheading"];if(__sv_17!==undefined){var __ib_18=_e.length;if(_e.length===__ib_18){__sv_17=__rfn_19(__sv_17);}
}
var __sv_20=__sv_9["text"];if(__sv_20!==undefined){var __ib_21=_e.length;if(_e.length===__ib_21){__sv_20=__rfn_22(__sv_20);}
}
var __sv_23=__sv_9["link"];if(__sv_23!==undefined){var __ib_24=_e.length;if(_e.length===__ib_24){__sv_23=__rfn_25(__sv_23);}
}
var __sv_26=__sv_9["links"];if(__sv_26!==undefined){var __ib_27=_e.length;if(_e.length===__ib_27){__sv_26=__rfn_28(__sv_26);}
}
var __sv_29=__sv_9["ctas"];if(__sv_29!==undefined){var __ib_30=_e.length;if(_e.length===__ib_30){__sv_29=__rfn_31(__sv_29);}
}
var __sv_32=__sv_9["cta"];if(__sv_32!==undefined){var __ib_33=_e.length;if(_e.length===__ib_33){__sv_32=__rfn_34(__sv_32);}
}
var __sv_35=__sv_9["media"];if(__sv_35!==undefined){var __ib_36=_e.length;if(_e.length===__ib_36){__sv_35=__rfn_37(__sv_35);}
}
var __sv_38=__sv_9["content"];if(__sv_38!==undefined){var __ib_39=_e.length;if(_e.length===__ib_39){__sv_38=__rfn_40(__sv_38);}
}
var __o_10={};if(__sv_11!==undefined||("id" in __sv_9)){__o_10["id"]=__sv_11;}if(__sv_12!==undefined||("htmlId" in __sv_9)){__o_10["htmlId"]=__sv_12;}if(__sv_13!==undefined||("label" in __sv_9)){__o_10["label"]=__sv_13;}if(__sv_16!==undefined||("heading" in __sv_9)){__o_10["heading"]=__sv_16;}if(__sv_17!==undefined||("subheading" in __sv_9)){__o_10["subheading"]=__sv_17;}if(__sv_20!==undefined||("text" in __sv_9)){__o_10["text"]=__sv_20;}if(__sv_23!==undefined||("link" in __sv_9)){__o_10["link"]=__sv_23;}if(__sv_26!==undefined||("links" in __sv_9)){__o_10["links"]=__sv_26;}if(__sv_29!==undefined||("ctas" in __sv_9)){__o_10["ctas"]=__sv_29;}if(__sv_32!==undefined||("cta" in __sv_9)){__o_10["cta"]=__sv_32;}if(__sv_35!==undefined||("media" in __sv_9)){__o_10["media"]=__sv_35;}if(__sv_38!==undefined||("content" in __sv_9)){__o_10["content"]=__sv_38;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_GenericContentSchema,__zs,null,null);
})()

export type GenericContent = z.infer<typeof GenericContentSchema>
